module.exports = __webpack_public_path__ + "img/photo-0083.ed3f4c9c.jpg";